import axios from "axios";

const AUTOCAB_BASE_URL = "https://autocab-api.azure-api.net";
const AUTOCAB_SUBSCRIPTION_KEY = "190ef61b14bc4435a0efbe4fcf4915b6";

/**
 * POST /booking/v1/calculateeta
 *
 * @param {Object} payload
 * @param {{longitude:number, latitude:number}[]} payload.points - Typically [from, to]
 * @param {string} payload.departureTime - ISO string e.g. new Date().toISOString()
 */
export const calculate_eta = (payload) => {
  if (!AUTOCAB_SUBSCRIPTION_KEY) {
    return Promise.reject(
      new Error(
        "Missing VUE_APP_AUTOCAB_SUBSCRIPTION_KEY. Set it in your environment to use Autocab ETA."
      )
    );
  }

  return axios.post(`${AUTOCAB_BASE_URL}/booking/v1/calculateeta`, payload, {
    headers: {
      "Ocp-Apim-Subscription-Key": AUTOCAB_SUBSCRIPTION_KEY,
    },
  });
};

